import { useCallback, useRef, useState } from 'react';

// Tracks keys whose action is in flight, preventing the same key from running
// concurrently and exposing a reactive busy state for the UI.
export const useBusyKeys = () => {
  const inFlight = useRef<Set<string>>(new Set());
  const [busyKeys, setBusyKeys] = useState<ReadonlySet<string>>(new Set());

  const runExclusive = useCallback(
    async (key: string, action: () => Promise<void>): Promise<void> => {
      if (inFlight.current.has(key)) return;
      inFlight.current.add(key);
      setBusyKeys(new Set(inFlight.current));
      try {
        await action();
      } finally {
        inFlight.current.delete(key);
        setBusyKeys(new Set(inFlight.current));
      }
    },
    [],
  );

  const isBusy = useCallback((key: string) => busyKeys.has(key), [busyKeys]);

  return { isBusy, runExclusive };
};
